import { render, staticRenderFns } from "./SaleLayout.vue?vue&type=template&id=c4221262&scoped=true&"
import script from "./SaleLayout.vue?vue&type=script&lang=js&"
export * from "./SaleLayout.vue?vue&type=script&lang=js&"
import style0 from "./SaleLayout.vue?vue&type=style&index=0&id=c4221262&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4221262",
  null
  
)

export default component.exports